export default {
  OpenSans: "'Open Sans', Helvetica, Arial, sans-serif",
};
